<template>
  <div class="full-body-content align-items-center">
    <b-row class="v-full justify-content-center">
      <b-col md="5" sm="6" align-self="center">
        <b-card no-body class="mx-4">
          <b-card-body class="p-4">
            <b-form>
              <h1 v-text="$t('menu.register')">Register</h1>
              <p class="text-muted" v-text="$t('menu.user_profile')">
                User Profile
              </p>
              <b-input-group class="mb-3">
                <b-input-group-prepend>
                  <b-input-group-text
                    ><i class="icon-user"></i
                    >{{ $t("menu.first_name") }}</b-input-group-text
                  >
                </b-input-group-prepend>
                <b-form-input
                  type="text"
                  class="form-control"
                  aria-describedby="inputFeedback_fn"
                  v-model.trim="first_name"
                  :placeholder="$t('menu.first_name')"
                  :state="nameState(first_name)"
                />
                <b-form-invalid-feedback id="inputFeedback_fn">
                  Enter at least 1 letters
                </b-form-invalid-feedback>
              </b-input-group>

              <b-input-group class="mb-3">
                <b-input-group-prepend>
                  <b-input-group-text
                    ><i class="icon-user"></i
                    >{{ $t("menu.last_name") }}</b-input-group-text
                  >
                </b-input-group-prepend>
                <b-form-input
                  type="text"
                  class="form-control"
                  aria-describedby="inputFeedback_ln"
                  v-model.trim="last_name"
                  :placeholder="$t('menu.last_name')"
                  :state="nameState(last_name)"
                />
                <b-form-invalid-feedback id="inputFeedback_ln">
                  Enter at least 1 letters
                </b-form-invalid-feedback>
              </b-input-group>

              <!-- this is a form text block (formerly known as help block) -->
              <div role="group" class="mb-3">
                <b-form-text v-if="first_name || last_name">
                  Hi, {{ first_name }} {{ last_name }}
                  <span v-if="first_name && last_name"
                    ><i class="fa fa-check-circle"></i
                  ></span>
                </b-form-text>
              </div>

              <b-input-group class="mb-3">
                <b-input-group-prepend
                  ><b-input-group-text
                    ><i class="cui-envelope-closed"></i></b-input-group-text
                ></b-input-group-prepend>
                <b-form-input
                  id="input_email"
                  type="email"
                  class="form-control"
                  v-model.trim="email"
                  autocomplete="email"
                  aria-describedby="inputFeedback_email"
                  :placeholder="$t('menu.email')"
                  :state="checkEmail"
                />
                <b-form-invalid-feedback id="inputFeedback_email">
                  <!-- This will only be shown if the preceeding input has an invalid state -->
                  Ex. abc@defg.com
                </b-form-invalid-feedback>
              </b-input-group>

              <p class="text-muted">
                {{ $t("menu.password") }}
                <i :class="showPasswordBtn" @click="switchShowPassword"></i>
              </p>
              <b-input-group class="mb-3">
                <b-input-group-prepend
                  ><b-input-group-text>
                    <i class="icon-lock"></i> </b-input-group-text
                ></b-input-group-prepend>
                <b-form-input
                  :type="p_show"
                  class="form-control"
                  v-model="password[0]"
                  :placeholder="$t('other.enter_the_password')"
                  :state="passwordState(0)"
                />
              </b-input-group>

              <b-input-group class="mb-4">
                <b-input-group-prepend
                  ><b-input-group-text>
                    <i class="icon-lock"></i> </b-input-group-text
                ></b-input-group-prepend>
                <b-form-input
                  :type="p_show"
                  class="form-control"
                  v-model="password[1]"
                  :placeholder="$t('other.enter_the_password_again')"
                  :state="passwordState(1)"
                />
              </b-input-group>
              <div class="recommend-password">
                建議密碼：{{ randomPassword }}
                <BtnCopyToClipboard
                  :copy_content="randomPassword"
                  :btn_text="''"
                  :tooltip_text="'copy password'"
                  btn_style="small"
                  :btn_variant="'outline-warning'"
                >
                </BtnCopyToClipboard>
              </div>
              <div class="err-msg">
                * {{ $t("other.password_info_format") }}
              </div>
              <div v-if="p_err.new_not_same" class="err-msg">
                * {{ $t("other.password_info_new_compare") }}
              </div>

              <br />
              <div class="mb-3 text-center">
                <b-form-checkbox
                  v-model="btn_agreeAgriLaw"
                  value="true"
                  unchecked-value="false"
                  name="agree"
                >
                  {{ $t("menu.accept_the_terms_and_use") }}
                </b-form-checkbox>
              </div>

              <b-button
                variant="success"
                block
                v-text="$t('other.create_account')"
                :disabled="checkRegisterBTN"
                @click="createAccount"
                >Create Account</b-button
              >

              <!-- 送出請求後的訊息 -->
              <br />
              <div v-if="checkState.failed" class="err-msg">
                {{ $t("other.register_failed") }}
              </div>
              <div v-if="checkState.succeeded" class="success-msg">
                {{ $t("other.register_succeeded") }}
              </div>
            </b-form>
          </b-card-body>
          <b-card-footer class="p-4">
            <b-row>
              <b-col md="5">
                <p class="text-muted" v-text="$t('other.have_an_agri_account')">
                  Have an agri account ?
                </p>
                <!-- <b-button block class="btn btn-facebook"><span>facebook</span></b-button> -->
              </b-col>
              <b-col md="7">
                <b-button
                  variant="secondary"
                  block
                  :to="{ name: 'Login' }"
                  v-text="$t('other.go_to_login_page')"
                  >Go to Login page !</b-button
                >
                <!-- <b-button block class="btn btn-twitter" type="button"><span>twitter</span></b-button> -->
              </b-col>
            </b-row>
          </b-card-footer>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
import BtnCopyToClipboard from "@/views/components/Button_CopyToClipboard";

export default {
  name: "Register",
  components: {
    BtnCopyToClipboard,
  },
  data() {
    return {
      first_name: "",
      last_name: "",
      email: "",
      checkState: {
        failed: false,
        succeeded: false,
      },

      // password
      randomPassword: "",
      password: ["", ""], // new, new 2
      p_show: "password",
      p_err: {
        new_format_err: false, // 新密碼格式不合
        new_not_same: false, // 新密碼兩次輸入不一樣
      },

      // button
      btn_agreeAgriLaw: false, // 使用者同意書
      btn_sentRequest: false, // 送出註冊按鈕
      btn_showPassword: false, // 顯示密碼
    };
  },
  mounted() {
    // 檢查 token 是否有效
    if (localStorage.token) {
      // console.log('有 token，可註冊');
      // console.log( this.user_admin )
      if (this.user_admin != true) {
        this.$router.push({ name: "Page404" });
      }
    } else {
      //   console.log('登入後才可註冊');
      this.$store
        .dispatch("user/logout")
        .then(() => {
          this.$router.push({ name: "Login" });
        })
        .catch((err) => {
          this.$router.push({ name: "Login" });
        });
    }
    this.init_AccountInfo();
  },
  computed: {
    ...mapState({
      user_admin: (state) => state.user.is_admin,
      user_email: (state) => state.user.email,
      user_first_name: (state) => state.user.first_name,
      user_last_name: (state) => state.user.last_name,
    }),

    checkEmail() {
      return this.$tools.input.checkEmail(this.email);
    },
    showPasswordBtn() {
      return this.$tools.input.showPasswordBtn(this.btn_showPassword).class;
    },
    checkRegisterBTN() {
      this.checkState.succeeded = false;
      this.checkState.failed = false;

      if (!this.nameState(this.first_name)) return true; // 名字檢核沒過
      if (!this.nameState(this.last_name)) return true; // 姓氏檢核沒過
      if (!this.checkEmail) return true; // 信箱檢核沒過

      if (this.password[0].length == 0) return true; // 沒有輸入新密碼  就 disable
      if (this.password[1].length == 0) return true; // 沒有輸入新密碼2 就 disable
      if (this.p_err.new_format_err || this.p_err.new_not_same) return true; // 密碼檢核沒過

      if (!this.btn_agreeAgriLaw) return true; // 使用者同意書沒勾

      return this.btn_sentRequest;
    },
  },
  methods: {
    init_AccountInfo() {
      this.first_name = "";
      this.last_name = "";
      this.email = "";
      this.password = ["", ""];
      this.get_RandomPassword();
    },

    get_RandomPassword() {
      // 確認隨機碼裡含有數字
      let _randon_code = this.$tools.input.randomCode();
      while (this.$tools.num.checkHasNumber(_randon_code) == false) {
        _randon_code = this.$tools.input.randomCode();
      }

      this.randomPassword = "agriFriend@" + _randon_code;
    },

    createAccount() {
      this.btn_sentRequest = true;
      const options = {
        method: "POST",
        url: this.$config.getAPI_URL("Register"),
        data: {
          first_name: this.first_name,
          last_name: this.last_name,
          email: this.email,
          password: this.password[0],
        },
      };
      this.$http(options)
        .then((res) => {
          this.checkState.succeeded = true;
          this.checkState.failed = false;
          this.btn_sentRequest = false;
          this.write_OPLog("admin create", options.data);
          this.$toastr.s(this.$t("other.register_succeeded"), this.email);
          this.init_AccountInfo();
        })
        .catch((err) => {
          // console.log('註冊失敗');
          // console.log(err);
          this.checkState.succeeded = false;
          this.checkState.failed = true;
          this.btn_sentRequest = false;
          this.$toastr.e(this.$t("other.register_failed"), this.email);
        });
    },

    write_OPLog(action, querySettings = {}) {
      // 送出使用者操作紀錄 --------------------
      let _OPLog = {
        user_id: this.$store.state.user.id,
        type: "write",
        detail: {
          page: "user",
          action: action,
          querySettings: {},
          pageInfo: {
            "executor email": this.user_email,
            "executor name": this.user_last_name + " " + this.user_first_name,
          },
        },
      };

      for (let setting in querySettings) {
        _OPLog.detail.querySettings[setting] = querySettings[setting];
      }
      this.$store
        .dispatch("user/createLog", _OPLog)
        .then((res) => {})
        .catch((err) => {});
      // 送出使用者操作紀錄 --------------------
    },

    // 檢查機制
    nameState(name) {
      return this.$tools.input.checkName(name);
    },
    passwordState(idx) {
      return this.$tools.input.checkPasswordList(
        idx,
        this.password,
        this.p_err,
        false
      );
    },
    switchShowPassword() {
      this.btn_showPassword = !this.btn_showPassword;
      this.p_show = this.$tools.input.showPasswordBtn(
        this.btn_showPassword
      ).inputType;
    },
  },
};
</script>

